/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TaskInTableResponse model module.
 * @module model/TaskInTableResponse
 * @version 2.8.0
 */
class TaskInTableResponse {
    /**
     * Constructs a new <code>TaskInTableResponse</code>.
     * @alias module:model/TaskInTableResponse
     * @param creationDate {String} 
     */
    constructor(creationDate) { 
        
        TaskInTableResponse.initialize(this, creationDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, creationDate) { 
        obj['creationDate'] = creationDate;
    }

    /**
     * Constructs a <code>TaskInTableResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TaskInTableResponse} obj Optional instance to populate.
     * @return {module:model/TaskInTableResponse} The populated <code>TaskInTableResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TaskInTableResponse();

            if (data.hasOwnProperty('creationDate')) {
                obj['creationDate'] = ApiClient.convertToType(data['creationDate'], 'String');
            }
            if (data.hasOwnProperty('resultDate')) {
                obj['resultDate'] = ApiClient.convertToType(data['resultDate'], 'String');
            }
            if (data.hasOwnProperty('errorDate')) {
                obj['errorDate'] = ApiClient.convertToType(data['errorDate'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} creationDate
 */
TaskInTableResponse.prototype['creationDate'] = undefined;

/**
 * @member {String} resultDate
 */
TaskInTableResponse.prototype['resultDate'] = undefined;

/**
 * @member {String} errorDate
 */
TaskInTableResponse.prototype['errorDate'] = undefined;






export default TaskInTableResponse;

